function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.5,
    height: 24,
    viewBox: "0 0 25.5 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8687"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "camera (4)",
    transform: "translate(.75 2)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 35839",
    d: "M25 20.455a2.182 2.182 0 0 1-2.182 2.182H3.182A2.182 2.182 0 0 1 1 20.455v-12a2.182 2.182 0 0 1 2.182-2.182h4.363L9.727 3h6.545l2.182 3.273h4.364A2.182 2.182 0 0 1 25 8.455z",
    transform: "translate(-1 -3)",
    style: {
      fill: "none",
      stroke: "#6c7c8c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 383",
    cx: 4.364,
    cy: 4.364,
    r: 4.364,
    transform: "translate(7.636 6.545)",
    style: {
      fill: "none",
      stroke: "#6c7c8c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.40cde39f6de996331f006d2561e928bd.svg";
export { ForwardRef as ReactComponent };